(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-slide"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBar(root) {
    if (!root || root.getAttribute('data-ann-init') === 'true') return;
    root.setAttribute('data-ann-init', 'true');

    var items = root.querySelectorAll('[data-ann-item]');
    if (items.length < 2) return;

    var index = 0;
    var timer = null;
    var delay = parseFloat(root.getAttribute('data-ann-autoplay') || '5') * 1000;
    if (isNaN(delay) || delay < 1500) delay = 5000;

    function show(next) {
      if (next === index) return;
      var current = items[index];
      var upcoming = items[next];

      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      current.setAttribute('aria-hidden', 'true');
      var currentLink = current.querySelector('a');
      if (currentLink) currentLink.setAttribute('tabindex', '-1');

      window.setTimeout(function () {
        current.classList.remove('is-leaving');
      }, 600);

      upcoming.classList.add('is-active');
      upcoming.removeAttribute('aria-hidden');
      var nextLink = upcoming.querySelector('a');
      if (nextLink) nextLink.removeAttribute('tabindex');

      index = next;
    }

    function step(dir) {
      show((index + dir + items.length) % items.length);
    }

    function start() {
      stop();
      timer = window.setInterval(function () {
        step(1);
      }, delay);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    var prev = root.querySelector('[data-ann-prev]');
    var next = root.querySelector('[data-ann-next]');

    if (prev) {
      prev.addEventListener('click', function () {
        step(-1);
        start();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        step(1);
        start();
      });
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    root.annStop = stop;
    start();
  }

  function initAll(scope) {
    var bars = (scope || document).querySelectorAll('[data-ann-slide]');
    for (var i = 0; i < bars.length; i++) initBar(bars[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var bars = e.target.querySelectorAll ? e.target.querySelectorAll('[data-ann-slide]') : [];
    for (var i = 0; i < bars.length; i++) {
      if (bars[i].annStop) bars[i].annStop();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-deal-event"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function toIso(raw, offset) {
    var value = (raw || '').trim();
    if (!value) return '';
    value = value.replace(' ', 'T');
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)) {
      value += ':00';
    }
    if (/(Z|[+\-]\d{2}:?\d{2})$/.test(value)) {
      return value;
    }
    var zone = (offset || '').trim();
    if (!zone) zone = 'Z';
    if (/^[+\-]\d{4}$/.test(zone)) {
      zone = zone.slice(0, 3) + ':' + zone.slice(3);
    }
    if (/^\d{2}:\d{2}$/.test(zone)) {
      zone = '+' + zone;
    }
    return value + zone;
  }

  function endSale(root, countdown) {
    if (countdown) countdown.hidden = true;
    var ended = root.querySelector('[data-hde-ended]');
    if (ended) ended.hidden = false;
    var urgency = root.querySelector('[data-hde-urgency]');
    if (urgency && urgency.getAttribute('data-hde-hide-on-end') === 'true') {
      urgency.hidden = true;
    }
  }

  function startVideo(root) {
    var video = root.querySelector('[data-hde-video]');
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        // Autoplay refused (e.g. battery saver) - the poster image stays visible.
      });
    }
  }

  function init(root) {
    if (!root || root.getAttribute('data-hde-init') === 'true') return;
    root.setAttribute('data-hde-init', 'true');

    startVideo(root);

    var countdown = root.querySelector('[data-hde-countdown]');
    if (!countdown) return;

    var iso = toIso(countdown.getAttribute('data-hde-ends-at'), countdown.getAttribute('data-hde-utc-offset'));
    var target = Date.parse(iso);

    if (isNaN(target)) {
      countdown.hidden = true;
      return;
    }

    var cycleMs = (parseFloat(countdown.getAttribute('data-hde-restart-hours')) || 0) * 3600000;
    var restarts = countdown.getAttribute('data-hde-restart') === 'true' && cycleMs > 0;

    var dayEl = countdown.querySelector('[data-hde-days]');
    var hourEl = countdown.querySelector('[data-hde-hours]');
    var minEl = countdown.querySelector('[data-hde-minutes]');
    var secEl = countdown.querySelector('[data-hde-seconds]');
    var timer = null;

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      root.hdeTimer = null;
    }

    function tick() {
      var remaining;

      if (restarts) {
        // Rolling clock: fixed-length cycles phased on the deadline's time of
        // day, so it snaps back to a full cycle at the same moment every day
        // and every visitor sees the same value. This is deliberately the same
        // maths as sections/ffx-summer-sale-banner.liquid, and with the same
        // anchor the two timers stay in lockstep to the second.
        var offset = (Date.now() - target) % cycleMs;
        if (offset < 0) offset += cycleMs;
        remaining = cycleMs - offset;
      } else {
        remaining = target - Date.now();

        if (remaining <= 0) {
          stop();
          endSale(root, countdown);
          return;
        }
      }

      var totalSeconds = Math.floor(remaining / 1000);
      if (restarts) totalSeconds = Math.min(totalSeconds, Math.floor(cycleMs / 1000) - 1);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (dayEl) dayEl.textContent = pad2(days);
      if (hourEl) hourEl.textContent = pad2(hours);
      if (minEl) minEl.textContent = pad2(minutes);
      if (secEl) secEl.textContent = pad2(seconds);
    }

    tick();
    if (restarts || target - Date.now() > 0) {
      timer = setInterval(tick, 1000);
      root.hdeTimer = timer;
    }
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.hero-deal-event');
    for (var i = 0; i < nodes.length; i++) {
      init(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var nodes = event.target.querySelectorAll ? event.target.querySelectorAll('.hero-deal-event') : [];
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].hdeTimer) {
        clearInterval(nodes[i].hdeTimer);
        nodes[i].hdeTimer = null;
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
